import React from 'react'
import styled from 'styled-components'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import { FINAL_DONATION_TOTAL } from '../data/donationSummary'
import PropTypes from 'prop-types'
import { aboutSection1Type, aboutSection2Type, aboutSection3Type, aboutPartnersSectionType, aboutSection4Type, aboutOurVolunteersType } from '../proptypes/about-proptypes'
import Section1 from '../components/about/Section1';
import Section2 from '../components/about/Section2';
import Section3 from '../components/about/Section3';
import OurPartners from '../components/about/OurPartners';
import Section4 from '../components/about/Section4';
import OurVolunteers from '../components/about/OurVolunteers';

const StyledSection1 = styled(Section1)`
  min-height: 500px;
  max-height: 900px;
  background-color: #01babd6b;
  background-image: linear-gradient(to left,rgba(0,125,130,0),#01babd26 64%,#01babd33);
  @media (max-width: ${props => props.theme.breakpoints[2]}) {
    max-height: initial;
  }
`

const StyledSection2 = styled(Section2)`
`

const StyledSection3 = styled(Section3)`
  background-color: #008b90;
  background-image: linear-gradient(to left, rgba(0, 125, 130, 0), #016165 64%, #016468);
  @media (max-width: 374px) {
    background-color: #018388;
  }
`
const StyledSection4 = styled(Section4)`
`

const AboutPage = class extends React.Component {
  constructor(props) {
    super(props);
    // Donations are closed, so the total is fixed (see src/data/donationSummary.js)
    this.state = {
      totalDonationAmount: FINAL_DONATION_TOTAL,
    };
  }

  render() {
    const { markdownRemark: markdownData } = this.props.data
    const frontmatter = markdownData.frontmatter;
    const section1 = frontmatter.section1;
    const section2 = frontmatter.section2;
    const section3 = frontmatter.section3;
    const aboutPartnersSection = frontmatter.aboutPartnersSection;
    const section4 = frontmatter.section4;
    const ourVolunteers = frontmatter.ourVolunteers;

    return (
      <Layout>
        <StyledSection1 section1={section1} donationAmount={this.state.totalDonationAmount} />
        <StyledSection2 section2={section2} />
        <StyledSection3 section3={section3} />
        <OurPartners aboutPartnersSection={aboutPartnersSection} />
        <StyledSection4 section4={section4} />
        <OurVolunteers ourVolunteers={ourVolunteers} />
      </Layout>
    )
  }
}

export default AboutPage;

AboutPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.shape({
        content: PropTypes.object,
        contentComponent: PropTypes.func,
        section1: aboutSection1Type.isRequired,
        section2: aboutSection2Type.isRequired,
        section3: aboutSection3Type.isRequired,
        aboutPartnersSection: aboutPartnersSectionType.isRequired,
        section4: aboutSection4Type.isRequired,
        ourVolunteers: aboutOurVolunteersType.isRequired,
      }).isRequired
    }).isRequired
  }).isRequired,
}

export const aboutPageQuery = graphql`
  query AboutPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        section1 {
          heading1
          description1
        }
        section2 {
          section
          definition1
          definition2
          definition3
          source
        }
        section3 {
          section
          belief1 {
            heading
            description
          }
          belief2 {
            heading
            description
          }
          belief3 {
            heading
            description
          }
        }
        aboutPartnersSection {
          section
          partner1 {
            heading
            description
          }
          partner2 {
            heading
            description
          }
        }
        section4 {
          section
          director1 {
            name
            role
            description
          }
          director2 {
            name
            role
            description
          }
          director3 {
            name
            role
          }
          director4 {
            name
            role
          }
        }
        ourVolunteers {
          section
          volunteers {
            name
            role
            linkedIn
            image {
              childImageSharp {
                fluid(maxWidth: 240, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`
